<dialog
  mibDialogInitialFocus
  class="mib-dialog block"
  [class.mib-modal-dark]="isDark"
  [class.dark]="isDark"
  aria-modal="true"
  [attr.aria-labelledby]="titleId">
  <form class="flex flex-col gap-6" [formGroup]="editionForm" (ngSubmit)="submitForm()">
    <header class="flex items-start justify-between gap-3">
      <h3 [id]="titleId" class="text-xl">{{ data.dialogTitle }}</h3>
      @if (data.showCloseButton !== false) {
        <button
          mibButton
          data-mib-dialog-close
          theme="secondary"
          size="sm"
          [attr.aria-label]="data.closeLabel || 'Close'"
          (click)="dialogRef.close()">
          <svg mib-icon name="x"></svg>
        </button>
      }
    </header>
    <div class="flex flex-col gap-3 min-h-23">
      <div class="flex flex-col gap-1">
        <label [for]="fieldId" class="text-sm">{{ data.fieldLabel }}</label>
        <textarea
          [id]="fieldId"
          formControlName="title"
          class="mib-textarea mib-scrollbar"
          [mibFieldDescribedBy]="errorId"
          [rows]="data.fieldRows || 1"
          [maxlength]="TITLE_MAX_LENGTH"
          [placeholder]="data.fieldPlaceholder || ''"
          (input)="updatePromptHeight($event)"></textarea>
        @if ((titleControl.dirty || titleControl.touched) && titleControl.invalid) {
          <p [id]="errorId" class="text-mib-danger dark:text-mib-danger-dark">
            @if (titleControl.errors?.['required']) {
              {{ data.fieldLabel }} is required
            }
            @if (titleControl.errors?.['maxlength']) {
              {{ data.fieldLabel }} too long
            }
          </p>
        }
      </div>
    </div>
    <footer class="flex gap-3 justify-end">
      <button mibButton theme="secondary" (click)="dialogRef.close()">Cancel</button>
      <button
        mibButton
        type="submit"
        [disabled]="editionForm.pristine || editionForm.invalid || data.currentValue === titleControl.getRawValue()">
        {{ data.confirmButtonLabel || 'Save' }}
      </button>
    </footer>
  </form>
</dialog>
